import React from 'react';
import { ArrowDropRight } from '@clds/icon';

export default {
  visible: true,
  depth: 0,
  toggleIcon: <ArrowDropRight />,
  size: 'md',
};
